import React from 'react';
import _ from 'lodash';
import {
  SiteNavigation,
  SiteNavigationMenu,
  SiteNavigationMenuItem
} from 'components/clarity-ui';

/**
 * Site Navigation Layout.
 */
class SiteNavigationLayout extends React.Component {

  /**
  * Renders the Navigation Menu/SubMenu Items Options
  *
  * @return {JSX} JSX component markup.
  **/
  renderItemOptions (menuOptions, selectedMenuItem) {
    const renderedOptions = menuOptions.map((menuItem) => {
      const isSubMenuActive = !!_.filter(menuItem.subMenu, {id: selectedMenuItem}).length;
      const isActive = selectedMenuItem === menuItem.id || isSubMenuActive ? true : false;
      return (
        <SiteNavigationMenuItem
          id={menuItem.id}
          key={menuItem.id}
          menuName={menuItem.name}
          iconClass={menuItem.iconClass}
          linkTo={menuItem.linkTo}
          onClick={this.props.handleClick.bind(this)}
          isActive={isActive}
        >
          { !_.isEmpty(menuItem.subMenu) ? this.renderMenuOptions(menuItem.subMenu, selectedMenuItem, 'subMenu', isActive) : null }
        </SiteNavigationMenuItem>
      )
    });
    return renderedOptions;
  }

  /**
  * Renders the Navigation Menu/SubMenu Options
  *
  * @return {JSX} JSX component markup.
  **/
  renderMenuOptions (menuOptions, selectedMenuItem, menuType, isActive) {
    return (
      <SiteNavigationMenu menuType={menuType} isActive={isActive}>
        { this.renderItemOptions(menuOptions, selectedMenuItem) }
      </SiteNavigationMenu>
    );
  }

  /**
  * Render the component
  *
  * @return {JSX} JSX component markup.
  **/
  render () {
    const { menuOptions, selectedMenuItem } = this.props;
    return (
      <SiteNavigation>
        { this.renderMenuOptions(menuOptions, selectedMenuItem, 'menu') }
      </SiteNavigation>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Icon component
 */
SiteNavigationLayout.propTypes = {
  handleClick: React.PropTypes.func,
  menuOptions: React.PropTypes.array,
  selectedMenuItem: React.PropTypes.string.isRequired
};

export default SiteNavigationLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/siteNavigation.layout.jsx